/**
 * @generated SignedSource<<bcc75777c15a281c5baffecab83fc6a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFileInput = {
  files?: ReadonlyArray<string | null> | null;
  taskId?: string | null;
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteFileMutationModernMutation$variables = {
  input: DeleteFileInput;
};
export type deleteFileMutationModernMutation$data = {
  readonly deleteFile: {
    readonly deletedFileIds: ReadonlyArray<string | null> | null;
    readonly blockedFileIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteFileMutationModernMutation = {
  variables: deleteFileMutationModernMutation$variables;
  response: deleteFileMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilePayload",
    "kind": "LinkedField",
    "name": "deleteFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFileIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "blockedFileIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aaf6ea9d2c036c50abb61ba3fd47a33f",
    "id": null,
    "metadata": {},
    "name": "deleteFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFileMutationModernMutation(\n  $input: DeleteFileInput!\n) {\n  deleteFile(input: $input) {\n    deletedFileIds\n    blockedFileIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed4e923715b9d93e0f41d3f921d1569e";

export default node;
